import React from 'react'
import Dialog from 'material-ui/Dialog'
import NewMessageForm from '../NewMessageForm'
import { themeColors } from '../../styles/theme'
import FlatButton from 'material-ui/FlatButton'
import ReactModal from 'react-modal'
import Close from 'material-ui/svg-icons/navigation/close'
import IconButton from 'material-ui/IconButton'
import TextField from 'material-ui/TextField'

const modalStyles = {
  header: {
    height: 52,
    backgroundColor: themeColors.positive,
    color: themeColors.white,
    display: 'flex',
    alignItems: 'center',
  },
  footer: {
    height: 50,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: themeColors.lightBackground,
    color: themeColors.white,
    display: 'flex',
    alignItems: 'center',
  },
}

const MessageModal = (
  { open, onRequestClose, onSubmit, onSubmitSuccess, user } // <Dialog //   title={`Invia messaggio a ${user.nome}`} //   titleStyle={{ backgroundColor: themeColors.lightBackground }}
) => //   autoScrollBodyContent={true}
//   modal={false}
//   contentClassName="fullwidth-for-small"
//   open={open}
//   onRequestClose={onRequestClose}>
//   <NewMessageForm
//     label="Testo del messaggio"
//     onClose={onRequestClose}
//     onSubmit={onSubmit}
//     onSubmitSuccess={onSubmitSuccess}
//   />
// </Dialog>
// )

(
  <ReactModal
    isOpen={open}
    onRequestClose={onRequestClose}
    contentLabel="Invia Messaggio"
    style={{
      overlay: {
        zIndex: 10000000,
      },
      content: {
        position: 'fixed',
        top: '0px',
        bottom: '0px',
        left: '0px',
        right: '0px',
        padding: 0,
      },
    }}>
    <div style={modalStyles.header}>
      <IconButton
        onClick={onRequestClose}
        iconStyle={{ color: themeColors.white }}>
        <Close />
      </IconButton>
      <span>{`Invia messaggio a ${user.username}`}</span>
    </div>
    <div className="padding-little-for-small">
      <NewMessageForm
        label="Testo del messaggio"
        onClose={onRequestClose}
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
      />
    </div>
    <div style={modalStyles.footer} />
  </ReactModal>
)

export default MessageModal



// WEBPACK FOOTER //
// ./src/common/Swap/MessageModal.js